import { render, staticRenderFns } from "./DesignerV2Page.vue?vue&type=template&id=7e5423a8&scoped=true&"
import script from "./DesignerV2Page.vue?vue&type=script&lang=js&"
export * from "./DesignerV2Page.vue?vue&type=script&lang=js&"
import style0 from "./DesignerV2Page.vue?vue&type=style&index=0&id=7e5423a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e5423a8",
  null
  
)

export default component.exports